module.exports = __webpack_public_path__ + "img/arrow.730247cf.svg";